import React from 'react'
import { useNavigate } from 'react-router-dom'

const HomeAbout = ({aboutUs}) => {
    const navigate = useNavigate()
    return (
        <>
            <section className='homeabout'>
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <h4 className='heading'><span style={{ whiteSpace: 'nowrap' }}>About us </span> <span className='linev'></span> </h4>
                        </div>
                    </div>
                    <div className="row align-items-center pt-4">
                        <div className="col-md-6">
                            <div className='pe-md-4'>
                                <img src={aboutUs.image} className='img-fluid rounded-2' alt="" />
                            </div>
                        </div>
                        <div className="col-md-6">
                            {/* {aboutUs.heading}
                            <p className='font-sm'>{aboutUs.paragraph}</p> */}

                           <span dangerouslySetInnerHTML={{ __html: aboutUs?.heading }} />
                           <p className='font-sm' dangerouslySetInnerHTML={{ __html: aboutUs?.paragraph }} />


                            <button onClick={() => navigate("/about-us")} className='btn btn-danger'>Learn more </button>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default HomeAbout
